import React, { Component } from 'react'
import styled from 'styled-components'
import SearchInput, {createFilter} from 'react-search-input'
import { RadioGroup, Radio } from 'react-radio-group'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { flow } from 'lodash'
import { bindActionCreators } from 'redux'
import { setEvent } from '../../modules/interviewResult'
import Loader from '../../components/LoaderOverlay'

const Content = styled.div`

  p {
    font-weight:300;
    font-size: 12px;
    color: #959595;
    letter-spacing: 0.94px;
    line-height: 23px;
    margin-bottom:20px;
  }

  input {
    margin-bottom:35px;
    display:block;
    float:none;
    outline:none;
    border:1px solid #696969;
    padding:10px 15px;
    border-radius:3px;
  }

  .search-input {
    input {
      width:100%;
    }
  }

  h2 {
    margin-bottom:8px;
  }

  .search-container {
    width: 100%;
    padding:15px;
    border:1px solid #696969;
    display:block;
    box-sizing:border-box;
    text-align:left;
    overflow:auto;
    margin-bottom:15px;

    .mail {
      width: 100%;
    }

    .from, .subject {
      width: 50%;
      float:left;
      color:#696969;
    }
  }
`

const RadioContainer = styled.label`
  padding:10px;
  margin-bottom:10px;
  border-radius:3px;
  display:block;

  input {
    display:inline;
    margin-right:15px;
    margin-bottom:6px;
  }

  label {
    color: #696969;
    font-size:12px;
  }
`

const enabledRadio = {border: "1px solid #34A8F0"}
const disabledRadio = {border: "1px solid rgba(0,0,0,0.1)"}

const Next = styled.a`
  background: #FFFFFF;
  border: 1px solid #34A8F0;
  box-shadow: 0 0 6px 0 rgba(0,0,0,0.21);
  border-radius: 3px;
  text-transform:uppercase;
  color: #34A8F0;
  padding: 15px 0;
  text-decoration:none;
  cursor:pointer;
`

const enabledNext = { pointerEvents: 'initial', opacity: 1 }
const disabledNext = { pointerEvents: 'none', opacity: 0.3 }

class OBFour extends Component {

  constructor(props) {
    super(props)
    this.state = {
      searchTerm: '',
      selectedValue: null,
      keys: ['event.name', 'event.date'],
      events: null
    }

    this.searchUpdated = this.searchUpdated.bind(this)
  }

  searchUpdated (term) {
    this.setState({searchTerm: term})
  }

  onChange = (value) => {
    this.setState({selectedValue: value});
    this.props.setEvent(value);
  }

  componentDidUpdate() {

    console.log('this props -> ', this.props)

    let events = this.props.data.account.account_apps[0].uniqueEventNames;
    let eventList = []

    if (this.props.data && !this.props.data.loading && !this.state.events){

      for (let i = 0; i < events.length; i++ ) {
        eventList.push({
          id: i,
          event: {
            name: events[i]
          }
        })
      }

      this.setState({
        events: eventList
      })
    }
  }

  render () {

    if(!this.state.events) {
      return <Loader />
    } else {
      const filteredEvents = this.state.events.filter(createFilter(this.state.searchTerm, this.state.keys))
      return (
        <Content>
          <h2>Critical Success Metric</h2>
          <p>What action <strong>must</strong> users perform? </p>
          <SearchInput className="search-input" onChange={this.searchUpdated} />
          <RadioGroup selectedValue={this.state.selectedValue} onChange={ this.onChange } style={{borderRadius: '3px', maxHeight: '200px', textAlign: 'left', marginBottom: '20px', overflowY: 'auto', color:'#4C4C4C', border: '#969696'}}>
            {filteredEvents.map(events => {
              return (
                <RadioContainer key={events.id} style={ this.state.selectedValue === events.event.name ? enabledRadio : disabledRadio }>
                  <Radio value={events.event.name} id={events.event.name} style={{padding: '15px', opacity: 1, color: '#34A8F0'}}/>{events.event.name}
                </RadioContainer>
              )
            })}
          </RadioGroup>
          <Next style={ this.state.selectedValue ? enabledNext : disabledNext} onClick={() => {this.props.changePage('/setup/usage-question')}}>Next</Next>
        </Content>
      )
    }
  }
}

const mapStateToProps = (state) => {
  return { event: state.interview.selectedEvent };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setEvent,
      changePage: (location) => push(location),
    },
    dispatch
  );

const getAccountApp = gql`
  query {
    account{
      name
      account_apps{
        id
        uniqueEventNames
      }
    }
  }
`;

const OnBoardingFour = flow(
  connect(mapStateToProps, mapDispatchToProps),
  graphql(getAccountApp)
)(OBFour);

export default OnBoardingFour



// WEBPACK FOOTER //
// ./src/containers/onBoard/onboardingFour.js